import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchCustomerSurveyResponses: DocumentNode = gql`
  query FetchCustomerSurveyResponses {
    fetchCustomerSurveyResponses {
      ... on CustomerSurveyResponses {
        surveys
      }
    }
  }
`

export default fetchCustomerSurveyResponses
